<template>
  <ubi-browser-context>
    <div v-if="isAuthenticating" class="App-loading" v-loading="true"></div>
    <!-- key=language forces the reload of all components when the language changes (problem with Element) -->
    <router-view v-else :key="getLangage"/>
  </ubi-browser-context>
</template>

<style lang="scss">
.App-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>

<script>
import { tryAuthenticateWithBrowserData } from '@/services/auth'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  metaInfo () {
    return {
      htmlAttrs: {
        lang: this.getLangage
      }
    }
  },
  data () {
    return {
      isAuthenticating: true
    }
  },
  computed: {
    ...mapGetters(['getLangage'])
  },
  async created () {
    await axios.interceptors.response.use((response) => response, (error) => {
      if (axios.isCancel(error)) {
        return
      }
      // catch default axios error, we can improve this part by using message depending on error code https://github.com/axios/axios#interceptors
      // Message.error($t('error.found'))
      return error
    })
  },
  async mounted () {
    this.isAuthenticating = true
    await tryAuthenticateWithBrowserData()
    this.isAuthenticating = false
  }
}
</script>
